"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/pt_PT");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  alternative_text_a834dcad: {
    message: "Texto Alternativo:"
  },
  announcement_list_da155734: {
    message: "Lista de an\xFAncio"
  },
  announcements_a4b8ed4a: {
    message: "An\xFAncios"
  },
  assignments_1e02582c: {
    message: "Tarefas"
  },
  background_color_press_down_to_select_ef99fdac: {
    message: "Cor de fundo, premir para baixo para selecionar"
  },
  c_2001_acme_inc_283f7f80: {
    message: "(c) 2001 Acme Inc."
  },
  cancel_file_upload_9903e7b9: {
    message: "Cancelar upload de ficheiro"
  },
  cancel_image_upload_2c771950: {
    message: "Cancelar upload de imagem"
  },
  cc_attribution_f6de631f: {
    message: "Atribui\xE7\xE3o CC"
  },
  cc_attribution_no_derivatives_b006744f: {
    message: "Atribui\xE7\xE3o CC n\xE3o \xE0 obras derivadas"
  },
  cc_attribution_non_commercial_39e0d30d: {
    message: "Atribui\xE7\xE3o CC uso n\xE3o comercial"
  },
  cc_attribution_non_commercial_no_derivatives_9fe74c00: {
    message: "Atribui\xE7\xE3o CC uso n\xE3o comercial, n\xE3o \xE0 obras derivadas"
  },
  cc_attribution_non_commercial_share_alike_c7edb1e5: {
    message: "Atribui\xE7\xE3o CC uso n\xE3o comercial, compartilhamento pela mesma licen\xE7a"
  },
  cc_attribution_share_alike_669e7f16: {
    message: "Atribui\xE7\xE3o CC compartilhamento pela mesma licen\xE7a"
  },
  check_if_the_image_is_decorative_283649b7: {
    message: "Verifique se a imagem \xE9 decorativa"
  },
  choose_usage_rights_33683854: {
    message: "Escolher direitos de utiliza\xE7\xE3o..."
  },
  click_any_file_to_insert_a_download_link_for_that__a708fa4c: {
    message: "Clique em qualquer arquivo para inserir um link de download para este arquivo."
  },
  click_any_image_to_embed_the_image_in_the_page_2cdd1136: {
    message: "Clique em qualquer imagem para incorpor\xE1-la \xE0 p\xE1gina."
  },
  click_any_page_to_insert_a_link_to_that_page_ac920c02: {
    message: "Clique em qualquer p\xE1gina para inserir um link para para essa p\xE1gina."
  },
  click_to_embed_image_33107dd8: {
    message: "Clique para incorporar imagem"
  },
  click_to_embed_imagename_c41ea8df: {
    message: "Clique para incorporar { imageName }"
  },
  click_to_insert_a_link_into_the_editor_c19613aa: {
    message: "Clique para inserir uma liga\xE7\xE3o no editor."
  },
  click_to_insert_a_link_to_this_item_39794098: {
    message: "Clique para inserir uma liga\xE7\xE3o para este item."
  },
  close_flickr_form_b32e600a: {
    message: "Fechar o formul\xE1rio Flickr"
  },
  collaborations_5c56c15f: {
    message: "Colabora\xE7\xF5es"
  },
  copyright_holder_66ee111: {
    message: "Titular dos direitos de autor:"
  },
  course_navigation_dd035109: {
    message: "Navega\xE7\xE3o da disciplina"
  },
  creative_commons_license_725584ae: {
    message: "Licen\xE7a Creative Commons:"
  },
  decorative_image_fde98579: {
    message: "Imagem decorativa"
  },
  discussions_a5f96392: {
    message: "Discuss\xF5es"
  },
  discussions_index_6c36ced: {
    message: "\xCDndice de discuss\xF5es"
  },
  embed_image_1080badc: {
    message: "Incorporar imagem"
  },
  enter_search_terms_e397b1f0: {
    message: "inserir termos de pesquisa"
  },
  enter_the_alternative_text_for_this_image_88047c47: {
    message: "Digite o texto alternativo para esta imagem"
  },
  file_upload_form_4aaad554: {
    message: "Formul\xE1rio de envio de ficheiro"
  },
  files_c300e900: {
    message: "Arquivos"
  },
  files_index_af7c662b: {
    message: "\xCDndice de arquivos"
  },
  folder_705fd2d7: {
    message: "Pasta"
  },
  font_size_press_down_to_select_6c25dc2d: {
    message: "Tamanho da letra, premir para baixo para selecionar"
  },
  formatting_press_down_to_select_df728c30: {
    message: "Formata\xE7\xE3o, premir para baixo para selecionar"
  },
  grades_a61eba0a: {
    message: "Notas"
  },
  group_navigation_99f191a: {
    message: "Navega\xE7\xE3o do grupo"
  },
  i_have_obtained_permission_to_use_this_file_6386f087: {
    message: "Obtive permiss\xE3o para utilizar este ficheiro."
  },
  i_hold_the_copyright_71ee91b1: {
    message: "Sou o titular dos direitos de autor"
  },
  if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5: {
    message: "Se voc\xEA n\xE3o selecionar os direitos de utiliza\xE7\xE3o agora, este ficheiro n\xE3o ser\xE1 publicado apor seu carregamento."
  },
  image_upload_form_7b74079a: {
    message: "Formul\xE1rio de Upload de Imagem"
  },
  images_7ce26570: {
    message: "Imagens"
  },
  insert_equella_links_49a8dacd: {
    message: "Inserir liga\xE7\xF5es do Equella"
  },
  insert_link_6dc23cae: {
    message: "Inserir liga\xE7\xE3o"
  },
  insert_math_equation_57c6e767: {
    message: "Inserir Equa\xE7\xE3o Matem\xE1tica"
  },
  link_7262adec: {
    message: "Liga\xE7\xE3o"
  },
  link_to_a_new_page_6c4ad034: {
    message: "Link para uma nova p\xE1gina"
  },
  link_to_other_content_in_the_course_879163b5: {
    message: "Associar a outro conte\xFAdo na disciplina."
  },
  link_to_other_content_in_the_group_3fe25379: {
    message: "Vincular a outros conte\xFAdos no grupo."
  },
  link_to_url_52dd935c: {
    message: "Liga\xE7\xE3o para URL"
  },
  links_14b70841: {
    message: "Links"
  },
  load_more_results_460f49a9: {
    message: "Carrega mais resultados"
  },
  loading_25990131: {
    message: "Carregando..."
  },
  loading_failed_b3524381: {
    message: "A carregar falhou..."
  },
  loading_folders_8d4d5d5a: {
    message: "A carregar pastas..."
  },
  modules_c4325335: {
    message: "M\xF3dulos"
  },
  no_results_940393cf: {
    message: "Nenhum resultado."
  },
  pages_e5414c2c: {
    message: "P\xE1ginas"
  },
  people_b4ebb13c: {
    message: "Pessoas"
  },
  quizzes_7e598f57: {
    message: "Testes"
  },
  record_upload_media_5fdce166: {
    message: "Gravar/Carregar M\xEDdia"
  },
  rich_text_area_press_alt_f8_for_help_58f0f2c3: {
    message: "\xC1rea Rich Text. Pressione ALT+F8 para ajuda"
  },
  search_280d00bd: {
    message: "Pesquisar"
  },
  search_flickr_6884b518: {
    message: "Procurar Flickr"
  },
  select_a_file_53ba40ac: {
    message: "Selecionar um ficheiro"
  },
  select_a_folder_to_upload_your_file_into_b82d12b: {
    message: "Selecione uma pasta para fazer o upload do ficheiro"
  },
  syllabus_f191f65b: {
    message: "Programa"
  },
  text_color_press_down_to_select_8f5ad9b5: {
    message: "Cor do texto, premir para baixo para selecionar"
  },
  the_material_is_in_the_public_domain_279c39a3: {
    message: "O material \xE9 de dom\xEDnio p\xFAblico"
  },
  the_material_is_licensed_under_creative_commons_3242cb5e: {
    message: "O material est\xE1 sujeito a licen\xE7a Creative Commons"
  },
  the_material_is_subject_to_fair_use_exception_41bc6a4b: {
    message: "O material est\xE1 sujeito \xE0 exce\xE7\xE3o de utiliza\xE7\xE3o justa"
  },
  this_upload_exceeds_the_file_storage_quota_please__c3a1b641: {
    message: "Esse carregamento excede a cota de armazenamento de ficheiro. Por favor, fale com o administrador do sistema."
  },
  upload_8b403d05: {
    message: "Upload"
  },
  upload_a_new_file_96e6d4ff: {
    message: "Upload de novo arquivo"
  },
  upload_a_new_image_890df275: {
    message: "Upload de nova imagem"
  },
  usage_right_ff96f3e2: {
    message: "Direito de utiliza\xE7\xE3o:"
  },
  what_would_you_like_to_call_the_new_page_d7e4488a: {
    message: "Que nome pretende dar \xE0 nova p\xE1gina?"
  },
  wiki_home_9cd54d0: {
    message: "P\xE1gina inicial do wiki"
  }
};

_formatMessage.default.addLocale({
  pt: locale
});